<header class="container ">
  <div class="maintenance-header text-secondary s_txt-sm border-bottom border-dark" >
    <div  ><strong>{{title}}:</strong> {{details }}</div>
    
  </div>
</header>